import React, { useCallback, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { Tooltip } from "antd";
import * as Styled from "./Styled";
import Report from "./CompanyLogin";
import { functionService } from "../../../lib/functions";
const PdfViewAction = () => {
    const [data, setData] = useState("");
    const [loading, setLoading] = useState(false);
    const [element, setElement] = useState("");
    const [downloadHover, setDownloadHover] = useState(false);

    const requestData = async () => {
        let obj = {
            assessment_id: "cb76ba45-b6ca-4fe2-9632-08a291a82c53",
          };
          try {
            let res = await functionService.getMockDetails(obj);
            let apiData = res?.response?.data?.formattedData[0];
            setData(apiData);
          } catch (error) {
            console.error("Error fetching recruiters list:", error);
          }
    };

    useEffect(() => {
        if (data) {
            let element =
                document && document.getElementById(`pdf-content-${data.id}`);
            setElement(element);
        }
    }, [data]);
    useEffect(() => {
        if (element) {
            func();
        }
    }, [element]);

    const func = async () => {
        if (element !== "") {
            const html2pdf = (
                await import("/node_modules/html2pdf.js/dist/html2pdf.min")
            ).default;
            let body = document.body
            let html = document.documentElement
            let height = Math.max(body.scrollHeight, body.offsetHeight,
                       html.clientHeight, html.scrollHeight, html.offsetHeight)

            let heightCM =  height/5
            let name= `${data?.name ? data?.name+"_" : ""}${
                    data?.test_title
                } assessment report`?.replace(/\./g, '')
            var opt = {
                 margin:[1,.5,1.3,.5] ,
                filename: name,
                // image:        { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2,letterRendering: true },
                pagebreak: ['avoid-all', 'css', 'legacy'],
                // pagebreak: {mode: 'avoid-all'},

              jsPDF: {
                    orientation: 'portrait',
                    unit: 'cm',
                    format:[ heightCM,23]
                }
            };
         

            try {
                html2pdf().set(opt).from(element).save();
                setElement("");
            } catch (e) {
                console.log(e);
            }
        }
    };
    const download =
        async () => {
            const assessmentDetails = await requestData();
        }

    return (
        <div>
            <Tooltip title="Download Report" color="#1e2228" overlayInnerStyle={{ borderRadius: "8px", padding: "6px 12px" }}>
                <Styled.EditWrapper
                    onClick={() =>
                        download()
                    }
                    // onMouseEnter={() => {
                    //     setCurrentInd(index);
                    //     setDownloadHover(true);
                    // }}
                    // onMouseLeave={() => {
                    //     setCurrentInd(index);
                    //     setDownloadHover(false);
                    // }}
                    // style={{
                    //     width: "32px",
                    //     height: "32px",
                    // }}
                >
                    A
                </Styled.EditWrapper>
            </Tooltip>

            {/* <Report data={data}/> */}
        </div>
    );
};

export default PdfViewAction;
